import * as React from "react";

function SvgLogo(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
      {...props}
    >
      <path
        d="M238.345 189.773h247.172c14.626 0 26.483 11.857 26.483 26.483v158.897c0 14.626-11.857 26.483-26.483 26.483H344.276v29.116c0 5.544-6.702 8.32-10.622 4.399l-33.516-33.515h-61.793c-14.626 0-26.483-11.857-26.483-26.483V216.256c0-14.626 11.857-26.483 26.483-26.483z"
        fill="#c3e678"
      />
      <path
        d="M211.862 216.256v158.897c0 1.9.218 3.746.599 5.534 61.705-24.77 105.332-85.043 105.332-155.603 0-12.122-1.353-23.918-3.795-35.31h-75.654c-14.625-.001-26.482 11.856-26.482 26.482z"
        fill="#a5d76e"
      />
      <path
        d="M300.138 225.083c0-82.881-67.188-150.069-150.069-150.069S0 142.202 0 225.083c0 72.598 51.555 133.146 120.05 147.054l45.199 45.199c4.171 4.171 11.303 1.217 11.303-4.682v-39.978c70.228-12.525 123.586-73.764 123.586-147.593z"
        fill="#ff6464"
      />
      <circle cx={150.069} cy={225.125} r={114.759} fill="#d2555a" />
      <g fill="#fff">
        <path d="M150.074 304.582h-.011c-4.875 0-8.833-3.957-8.833-8.833v-.006-.006c0-4.875 3.957-8.833 8.833-8.833h.011c4.875 0 8.833 3.957 8.833 8.833v.01c.001 4.878-3.957 8.835-8.833 8.835zM361.931 348.67a8.801 8.801 0 01-6.242-2.585l-44.138-44.138a8.825 8.825 0 010-12.483 8.827 8.827 0 0112.483 0l37.897 37.895 82.034-82.034a8.827 8.827 0 0112.483 0 8.825 8.825 0 010 12.483l-88.276 88.276a8.794 8.794 0 01-6.241 2.586zM150.069 269.261a8.829 8.829 0 01-8.828-8.828v-2.637c0-11.743 7.631-21.921 18.989-25.327 14.806-4.44 25.148-18.349 25.149-33.826.001-9.183-3.741-17.983-10.536-24.778-6.794-6.794-15.592-10.536-24.775-10.536h-.003c-19.469.001-35.308 15.841-35.308 35.31a8.829 8.829 0 01-17.656 0c0-29.203 23.758-52.963 52.962-52.966h.004c13.898 0 27.128 5.578 37.258 15.706 10.13 10.13 15.708 23.363 15.706 37.262-.002 23.211-15.518 44.074-37.732 50.735-3.831 1.149-6.406 4.531-6.406 8.416v2.637a8.822 8.822 0 01-8.824 8.832z" />
      </g>
    </svg>
  );
}

export default SvgLogo;
